import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { HttpTrialAccountRequestFilters, TrialAccountRequest } from './models';
import { TrialAccountRequestActions } from './store/actions';
import {
  selectFilters,
  selectIsError,
  selectIsLoading,
  selectRequests,
} from './store/selectors';
import { TrialAccountsRequestsState } from './store/state';

@Injectable()
export class TrialAccountsStateService {
  constructor(private readonly store: Store<TrialAccountsRequestsState>) {}

  public loadTrialRequests(httpFilters?: HttpTrialAccountRequestFilters[]) {
    this.store.dispatch(
      TrialAccountRequestActions.GetItems.request({ httpFilters }),
    );
  }

  public trialRequestApprove(
    accountId: string,
    requestId: string,
    redirect?: boolean,
  ) {
    this.store.dispatch(
      TrialAccountRequestActions.RequestApprove.request({
        accountId,
        requestId,
        redirect,
      }),
    );
  }

  public trialRequestDecline(requestId: string) {
    this.store.dispatch(
      TrialAccountRequestActions.RequestDecline.request({ requestId }),
    );
  }

  public addFilters(filters: HttpTrialAccountRequestFilters[]) {
    this.store.dispatch(TrialAccountRequestActions.Filters.add({ filters }));
  }

  public selectTrialRequests(): Observable<TrialAccountRequest[]> {
    return this.store.pipe(select(selectRequests));
  }

  public selectIsLoading(): Observable<boolean> {
    return this.store.pipe(select(selectIsLoading));
  }

  public selectIsError(): Observable<string> {
    return this.store.pipe(select(selectIsError));
  }

  public selectFilters(): Observable<HttpTrialAccountRequestFilters[]> {
    return this.store.pipe(select(selectFilters));
  }
}
